<template>
	<div class="row tabela-margin">
		<!-- Filtro -->
		<div v-show="exibirFiltro">
			<div class="col-xs-12 col-md-2 form-group">
				<div class="btn-group btn-block">
					<button
						type="button"
						class="btn btn-default btn-sm btn-block dropdown-toggle"
						data-toggle="dropdown"
						aria-haspopup="false"
						aria-expanded="false"
					>
						<i class="fa fa-fw fa-filter" aria-hidden="true"></i>
						{{ _traducao('global', 'filtro').toUpperCase() + ' ' }}
						<span class="caret"></span>
					</button>

					<ul class="dropdown-menu tabela-ul" :style="{'max-height': _height - 140 + 'px'}">
						<li :class="{active: filtroTodosAtivo}">
							<a @click.prevent.stop="clickFiltroTodos" href="#">{{ _traducao('global', 'todos').toUpperCase() }}</a>
						</li>
						<template v-for="coluna in colunasFiltro">
							<label class="label label-filtro label-info" :key="'label:' + coluna">{{
								labelColuna(coluna).toUpperCase()
							}}</label>
							<li role="separator" class="divider" :key="'separator:' + coluna"></li>
							<li
								v-for="valorColuna in valoresColunas[coluna]"
								:key="coluna + ':' + valorColuna"
								:class="{active: filtroAtivo(coluna, valorColuna)}"
							>
								<a @click.prevent.stop="clickFiltro(coluna, valorColuna)" href="#">{{ valorColuna }}</a>
							</li>
						</template>
					</ul>
				</div>
			</div>

			<div class="col-md-10 col-xs-12">
				<div class="row">
					<div v-for="(filtrosColuna, coluna) in filtros" :key="coluna">
						<div class="col-md-3 col-xs-12" v-for="(filtro, indexFiltro) in filtrosColuna" :key="indexFiltro">
							<div class="label-filtro-lista label-info" @click="removeFiltro(coluna, indexFiltro)">
								{{ coluna.toUpperCase() }}: {{ filtro.toUpperCase() }}
								<i class="fa pull-right fa-fw fa-times"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-xs-12" v-show="exibeBusca">
			<i class="fa fa-search icone-busca" aria-hidden="true"></i>
			<input
				type="text"
				style="padding-left: 22px; margin-top: 7px; margin-bottom: 6px"
				:placeholder="_traducao('global', 'buscar')"
				v-model="busca"
				class="form-control"
			/>
		</div>

		<!-- Tabela -->
		<div class="col-sm-12 tabela-margin-top">
			<div class="table-responsive">
				<table class="table table-lista table-striped table-hover">
					<thead>
						<tr>
							<th v-for="coluna in colunasTabela" :key="coluna.campo" :style="coluna.numerica ? 'text-align: right' : ''">
								<a href="#" @click.prevent="clickOrdenar(coluna.campo)">
									<i
										class="fa fa-fw fa-sort"
										:class="{
											'fa-sort-amount-asc': ordenacao.coluna == coluna.campo && ordenacao.sentidoCrescente,
											'fa-sort-amount-desc': ordenacao.coluna == coluna.campo && !ordenacao.sentidoCrescente
										}"
									></i>
									{{ coluna.nome }}
								</a>
							</th>
							<th v-if="exibeEditar" class="text-center">{{ _traducao('global', 'editar') }}</th>
							<th v-if="exibeExcluir" class="text-center">{{ _traducao('global', 'excluir') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(itemTabela, indexItemTabela) in dadosTabelaPaginaAtual" :key="indexItemTabela">
							<td v-for="coluna in colunasTabela" :key="coluna.campo" :style="coluna.numerica ? 'text-align: right' : ''">
								<span v-if="coluna.binaria">{{ itemTabela[coluna.campo] | transformaColunaBinaria }}</span>
								<span v-else-if="coluna.numerica">{{ itemTabela[coluna.campo] | transformaColunaNumberica }}</span>
								<span v-else-if="coluna.data">{{ itemTabela[coluna.campo] | transformaColunaData }}</span>
								<span v-else>{{ itemTabela[coluna.campo] }}</span>
							</td>
							<td v-if="exibeEditar" class="text-center">
								<a href="#" @click.prevent="clickEditar(itemTabela)" class="tabela-ta-a">
									<i class="fa icon-editar tabela-td-i"></i>
								</a>
							</td>
							<td v-if="exibeExcluir" class="text-center">
								<a href="#" @click.prevent="clickExcluir(itemTabela)" class="tabela-ta-a">
									<i class="fa icon-lixeira tabela-td-i"></i>
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- Paginacao -->
		<div class="col-md-12 text-center">
			<nav>
				<ul class="pagination paginacao-margin" :class="{'pagination-sm': !_isMobile}">
					<li :class="{disabled: paginacao.paginaAtual == 1}">
						<a href="#" @click.prevent="clickPaginaAnterior()">
							<span aria-hidden="true">
								<i class="fa fa-angle-left" aria-hidden="true"></i>
							</span>
						</a>
					</li>
					<li v-for="pagina in numeroDePaginas" :key="pagina" :class="{active: pagina == paginacao.paginaAtual}">
						<a href="#" @click.prevent="clickPagina(pagina)">{{ pagina }}</a>
					</li>
					<li :class="{disabled: paginacao.paginaAtual == numeroDePaginas}">
						<a href="#" @click.prevent="clickProximaPagina()">
							<span aria-hidden="true">
								<i class="fa fa-angle-right" aria-hidden="true"></i>
							</span>
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
var accents = require('remove-accents')

export default {
	props: {
		dadosTabela: {
			type: Array,
			required: true
		},

		colunasTabela: {
			type: Array,
			required: true
		},

		labelItem: {
			type: String,
			required: true
		},

		colunaDescricao: {
			type: String,
			required: true
		},

		colunasFiltro: {
			type: Array,
			required: false,
			default: []
		},

		exibeEditar: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeBusca: {
			type: Boolean,
			required: false,
			default: true
		},

		exibeExcluir: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data() {
		return {
			busca: '',
			ordenacao: {
				coluna: '',
				sentidoCrescente: true
			},

			paginacao: {
				paginaAtual: 1,
				resultadosPorPagina: 10
			},

			filtros: {}
		}
	},

	computed: {
		numeroDePaginas() {
			return Math.ceil(this.dadosTabelaFiltrados.length / this.paginacao.resultadosPorPagina)
		},

		dadosTabelaFiltrados() {
			let dadosTabela = this.dadosTabela.map((itemTabela) => {
				return Object.assign({}, itemTabela)
			})

			if (Object.keys(this.filtros).length) {
				dadosTabela = this.aplicaFiltros(dadosTabela)
			}

			if (this.busca) {
				dadosTabela = this.aplicaBusca(dadosTabela)
			}

			if (this.ordenacao.coluna) {
				dadosTabela = this.ordenaTabela(dadosTabela)
			}

			return dadosTabela
		},

		dadosTabelaPaginaAtual() {
			return this.dadosPaginaAtual(this.dadosTabelaFiltrados)
		},

		exibirFiltro() {
			return this.colunasFiltro.length > 0
		},

		valoresColunas() {
			let valores = {}

			this.colunasTabela.forEach((coluna) => {
				let valoresColuna = this.dadosTabela.map((itemTabela) => {
					return itemTabela[coluna.campo]
				})

				valores[coluna.campo] = [...new Set(valoresColuna)]
			})

			return valores
		},

		filtroTodosAtivo() {
			return Object.keys(this.filtros).length == 0
		}
	},

	filters: {
		transformaColunaBinaria(value) {
			if (!isNaN(value)) {
				value = Number(value)
			}

			if (value) {
				return 'Sim'
			}
			return 'Não'
		},
		transformaColunaNumberica(value) {
			return Number(value)
		},
		transformaColunaData(value) {
			const data = new moment(value, 'YYYY-MM-DD')
			return data.isValid() ? data.format('DD/MM/YYYY') : ''
		}
	},

	methods: {
		// Metodos Filtro

		clickFiltroTodos() {
			this.filtros = {}
		},

		posicaoFiltro(colunaFiltro, valorFiltro) {
			if (!(colunaFiltro in this.filtros)) {
				return -1
			}

			return this.filtros[colunaFiltro].findIndex((filtro) => {
				return filtro == valorFiltro
			})
		},

		clickFiltro(colunaFiltro, valorFiltro) {
			let indexFiltro = this.posicaoFiltro(colunaFiltro, valorFiltro)

			if (indexFiltro >= 0) {
				this.removeFiltro(colunaFiltro, indexFiltro)
			} else {
				if (!(colunaFiltro in this.filtros)) {
					this.$set(this.filtros, colunaFiltro, [])
				}
				this.filtros[colunaFiltro].push(valorFiltro)
			}
		},

		filtroAtivo(colunaFiltro, valorFiltro) {
			return this.posicaoFiltro(colunaFiltro, valorFiltro) >= 0
		},

		removeFiltro(colunaFiltro, indexFiltro) {
			this.filtros[colunaFiltro].splice(indexFiltro, 1)
		},

		// Metodos Tabela

		ordenaTabela(dadosTabela) {
			const coluna = this.colunasTabela.find((coluna) => {
				return coluna.campo === this.ordenacao.coluna
			})
			return dadosTabela.sort((itemTabela1, itemTabela2) => {
				let valorItem1 = itemTabela1[this.ordenacao.coluna]
				let valorItem2 = itemTabela2[this.ordenacao.coluna]

				if (typeof valorItem1 === 'string' && typeof valorItem2 === 'string') {
					valorItem1 = valorItem1.toLowerCase()
					valorItem2 = valorItem2.toLowerCase()
				}

				if (coluna.numerica) {
					valorItem1 = Number(valorItem1)
					valorItem2 = Number(valorItem2)
				}

				let resultado = 0
				if (valorItem1 > valorItem2) {
					resultado = 1
				} else if (valorItem1 < valorItem2) {
					resultado = -1
				}

				return this.ordenacao.sentidoCrescente ? resultado : -resultado
			})
		},

		aplicaFiltros(dadosTabela) {
			return dadosTabela.filter((itemTabela) => {
				for (let [coluna, filtrosColuna] of Object.entries(this.filtros)) {
					if (!filtrosColuna.length) {
						continue
					}

					let passouColuna = filtrosColuna.some((valorFiltro) => {
						return itemTabela[coluna] == valorFiltro
					})

					if (!passouColuna) {
						return false
					}
				}
				return true
			})
		},

		aplicaBusca(dadosTabela) {
			return dadosTabela.filter((itemTabela) => {
				return this.colunasTabela.some((colunaTabela) => {
					const valorItem = accents.remove(itemTabela[colunaTabela.campo] + '').toLowerCase()
					const valorBusca = accents.remove(this.busca).toLowerCase()
					return valorItem.indexOf(valorBusca) > -1
				})
			})
		},

		dadosPaginaAtual(dadosTabela) {
			let comeco = this.paginacao.resultadosPorPagina * (this.paginacao.paginaAtual - 1)
			let final = this.paginacao.resultadosPorPagina * this.paginacao.paginaAtual
			return dadosTabela.slice(comeco, final)
		},

		clickOrdenar(coluna) {
			if (this.ordenacao.coluna == coluna) {
				this.ordenacao.sentidoCrescente = !this.ordenacao.sentidoCrescente
			} else {
				this.ordenacao.coluna = coluna
				this.ordenacao.sentidoCrescente = true
			}
		},

		clickEditar(itemTabela) {
			this.$emit('click-editar', itemTabela)
		},

		clickExcluir(itemTabela) {
			let descricao = itemTabela[this.colunaDescricao]

			let texto = `<h3> ${this._traducao('global', 'desejaExcluir')} ${this.labelItem}?
							<br/>
							<span class='text-danger'>  ${descricao}</span>
						</h3>`
			this._modalExcluir(
				(retorno) => {
					if (retorno.excluir) {
						this.$emit('click-excluir', retorno.obj)
					}
				},
				itemTabela,
				texto,
				this._traducao('global', 'excluir').toUpperCase()
			)
		},

		labelColuna(campoColuna) {
			return this.colunasTabela.find((colunaTabela) => {
				return colunaTabela.campo == campoColuna
			}).nome
		},

		// Metodos Paginacao

		clickPaginaAnterior() {
			if (this.paginacao.paginaAtual > 1) {
				this.paginacao.paginaAtual--
			}
		},

		clickProximaPagina() {
			if (this.paginacao.paginaAtual < this.numeroDePaginas) {
				this.paginacao.paginaAtual++
			}
		},

		clickPagina(pagina) {
			this.paginacao.paginaAtual = pagina
		}
	}
}
</script>

<style scoped>
.paginacao-margin {
	margin: 0px;
}

.tabela-td-i {
	font-size: 20px;
}

.tabela-ta-a {
	margin-left: 6px;
	margin-right: 6px;
}

.tabela-margin {
	margin-top: 20px;
}

.tabela-ul {
	overflow: auto;
}

.tabela-margin-top {
	margin-top: 4px;
}
</style>